// Reusable CSV helpers. Callers build a grid of values (first row = headers);
// these handle escaping, the UTF-8 BOM, CRLF line endings, and the download.

export type CsvValue = string | number | null | undefined;

// Quote a field when it contains a delimiter, quote, or line break (and double
// up inner quotes), per RFC 4180.
function escapeCsvField(value: CsvValue): string {
  if (value === null || value === undefined) return "";
  const text = String(value);
  return /["\n\r,;]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

// Serialize a grid of rows to a CSV string. Prefixed with a UTF-8 BOM so Excel
// reads Cyrillic correctly; rows use CRLF line endings.
export function buildCsv(rows: CsvValue[][]): string {
  const body = rows.map((row) => row.map(escapeCsvField).join(",")).join("\r\n");
  return `\uFEFF${body}`;
}

// Build the CSV from `rows` and trigger a browser download. `.csv` is appended
// to `filename` when missing.
export function downloadCsv(filename: string, rows: CsvValue[][]): void {
  const url = URL.createObjectURL(new Blob([buildCsv(rows)], { type: "text/csv;charset=utf-8;" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.toLowerCase().endsWith(".csv") ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
